import type { DidYouKnowCard as DidYouKnowCardType } from "@/__generated__/api/wrenAPI.schemas";

/** Render markdown **bold** markers as <strong> tags. */
function renderBold(text: string) {
  const parts = text.split(/\*\*(.*?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i} className="font-semibold">{part}</strong> : part
  );
}

export function DidYouKnowCard({ data }: { data: DidYouKnowCardType }) {
  return (
    <div>
      <h3 className="text-xs font-semibold text-[#638308] uppercase tracking-wider px-1 mb-4">
        Did you know?
      </h3>
      <div className="bg-[#fdfcfa] rounded-2xl shadow-[0_1px_10px_rgba(0,0,0,0.08)] px-6 py-6">
        <div className="flex items-start gap-4">
          <span className="font-serif text-3xl text-[#3a3a3a] leading-none flex-shrink-0 pt-0.5">
            {data.number}
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-[#1a1a1a] leading-relaxed mb-2">
              {renderBold(data.body)}
            </p>
            <p className="text-xs text-[#999]">
              {data.source}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
